import React from 'react'
import { Row as StyledRow, Col as StyledCol } from './style'

export const Row = props => {
  const { children } = props
  return <StyledRow {...props}>{children}</StyledRow>
}

export const Col = props => {
  const { children, responsive } = props
  return (
    <StyledCol className="col" responsive={responsive}>
      <div className="col-inner">
        {children}
      </div>
    </StyledCol>
  )
}